import React, { useState } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import {
  ConditionalRenderer,
  Header,
  useLanguageTranslator,
} from "../../components";
import { FAQ } from "./faq";
import { BackArrowIcon, PlayLandingPageIcon } from "../../@lib/icons";
import { ContactForm } from "./form";

const Support: React.FC = () => {
  const [steps, setSteps] = useState(1);
  const { translator } = useLanguageTranslator();

  function onClickHandler() {
    setSteps(steps + 1);
  }

  function handleBackStep() {
    setSteps(steps - 1);
  }

  return (
    <Box>
      <Header
        title={"Support"}
        subtitle=""
        isSearchField={false}
      />

      <Box sx={{ backgroundColor: "white" }} m={5} p={5} borderRadius={"10px"}>
        <ConditionalRenderer condition={steps === 1}>
          <Typography
            textAlign={"center"}
            fontWeight={600}
            fontSize="31px"
            mb={3}
          >
            {translator("support.Get the help you need")}.
          </Typography>
          <Typography
            fontWeight={500}
            fontSize="14px"
            sx={{ color: "#494E54" }}
            ml={2}
          >
            {translator("support.People also ask")}:
          </Typography>
          <FAQ translator={translator} onClickHandler={onClickHandler} />
          <Stack
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "10px",
              position: "relative",
              backgroundImage: 'url("/assets/images/backgroundGetStarted.png")',
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
            px={8}
            py={5}
            mb={10}
            mt={5}
          >
            <Typography
              variant="h3"
              color={"white"}
              mt={3}
              className="landing-page-sub-footer"
            >
              {translator("support.Haven’t find the help you need?")}
            </Typography>
            <Typography
              color={"white"}
              mt={3}
              fontWeight={200}
              fontSize={"14px"}
              textAlign={"center"}
              className="landing-page-sub-footer"
            >
              {translator(
                "support.Our support team is here to assist you! If you have any questions, concerns, or need help with anything, please don’t hesitate to contact us. We’re committed to providing the best possible assistance and ensuring your satisfaction."
              )}
            </Typography>
            <Typography
              color={"white"}
              my={1}
              fontWeight={200}
              fontSize={"14px"}
              textAlign={"center"}
              className="landing-page-sub-footer"
            >
              {translator(
                "support.Reach out to us anytime—we’re just a message away!"
              )}
            </Typography>
            <Button
              sx={{
                backgroundColor: "white",
                padding: "8px 40px",
                color: "#F6A000",
                borderRadius: "10px",
                fontSize: "14px",
                textDecoration: "none",
                marginTop: "12px",
                height: "40px",
                "&:hover": {
                  color: "white",
                  border: "1px solid",
                  borderRadius: "10px",
                  borderColor: "white",
                  backgroundColor: "#F6A000",
                },
              }}
              onClick={onClickHandler}
            >
              {translator("support.Contact Us")}
            </Button>
          </Stack>
          <Stack
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: "white",
            }}
          >
            <Typography variant="h3" color={"#00AAB0"}>
              {translator("landingPage.Navigating the Niyel Tracker")}
            </Typography>
            <Typography variant="h5" mt={1}>
              {translator("landingPage.A STEP-BY-STEP GUIDE")}
            </Typography>
            <Typography
              variant="h6"
              color={"#494E54"}
              fontWeight={"500"}
              mt={1}
            >
              {translator(
                "landingPage.Welcome to the Niyel Tracker! Here’s how to navigate the platform and make the"
              )}
            </Typography>
            <Typography
              variant="h6"
              color={"#494E54"}
              fontWeight={"500"}
              mt={1}
            >
              {translator("landingPage.most of our rich data sets")}
            </Typography>
            <Stack
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
                backgroundImage: 'url("/assets/images/stepbystepBg.jpg")',
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                height: "100dvh",
                width: "100%",
                borderRadius: "10px",
              }}
              mb={10}
              mt={5}
            >
              <Stack
                textAlign={"center"}
                sx={{
                  backgroundColor: "white",
                  padding: "30px 30px",
                  borderRadius: "10px",
                }}
              >
                <div>
                  <PlayLandingPageIcon />
                </div>
                <Typography variant="h3">
                  {translator(
                    "landingPage.Learn how to navigate our platform easily by"
                  )}
                </Typography>
                <Typography variant="h3">
                  {translator("landingPage.watching this quick video!")}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </ConditionalRenderer>
        <ConditionalRenderer condition={steps === 2}>
          <div
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={handleBackStep}
          >
            <div>
              <BackArrowIcon />
            </div>
            <Typography
              sx={{ fontSize: "14px", marginLeft: "10px", fontWeight: "600" }}
            >
              {translator("support.Back")}
            </Typography>
          </div>
          <ContactForm />
        </ConditionalRenderer>
      </Box>
    </Box>
  );
};

export { Support };
